// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dialog-tip[data-v-812d449e]{margin-top:20px;padding:10px;background-color:#f0eeee}", ""]);
// Exports
module.exports = exports;
